import { __awaiter } from "tslib";
import env from '@/env';
import Header from './layout/header.vue';
import Message from './layout/message.vue';
import Tutorials from './layout/tutorials.vue';
import Breadcrumbs from './layout/breadcrumbs.vue';
import { status } from '@/alas';
import { showError, showInfo } from '@/store';
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api';
import { Self } from './vue-core';
export default defineComponent({
    components: {
        'self-header': Header,
        'self-message': Message,
        'self-tutorials': Tutorials,
        'self-breadcrumbs': Breadcrumbs
    },
    setup(props, context) {
        let self = new Self(context);
        let vuetify = context.root.$vuetify;
        // ================
        //
        // state
        //
        let $ = reactive({
            inited: false,
            config: status.fetch('config')
        });
        // ================
        //
        // computed
        //
        let layoutWidth = computed(() => status.fetch('user').$v.logged ? 1280 : undefined);
        // ================
        //
        // mounted
        //
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            vuetify.lang.current = 'zhHans';
            try {
                yield $.config.$o.fetch.seek();
            }
            catch (error) {
                showError(error);
            }
            try {
                yield status.fetch('user').$o.fetch.seek();
                yield status.fetch('userConfig').$o.fetch.seek();
            }
            finally {
                if (env.version !== $.config.clientVersion) {
                    showInfo(self.t('偵測到你的版本過於老舊，請<a onclick="location.reload()">點擊這裡</a>重整瀏覽器'));
                }
                $.inited = true;
            }
        }));
        // ================
        //
        // done
        //
        return {
            $,
            layoutWidth
        };
    }
});
